// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--ion-color-black);
}
ion-content .header-bg {
  background-image: url('email-confiramation-header-bg.png');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto;
  position: relative;
  background-color: rgba(18, 18, 18, 0.8);
}
ion-content .header-bg::before {
  content: "";
  background-color: rgba(18, 18, 18, 0.8);
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}
ion-content .footer-bg {
  background-image: url('email-confirmation-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 156px;
}
ion-content .content {
  position: relative;
  z-index: 2;
}
ion-content .content .logo {
  height: 50px;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 25px;
}
ion-content .content .success {
  width: 100%;
  height: 64px;
}
ion-content .content .title {
  font-family: Arial;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: var(--ion-color-white);
  margin-top: 25px;
}
ion-content .content .subtitle {
  font-family: Arial;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #d6d6d6;
  margin-top: 18px;
}
ion-content .wrapper {
  padding: 32px;
}
ion-content .header-block-title {
  font-family: Arial;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--ion-color-white);
  padding-bottom: 12px;
}
ion-content .header-block-title.with-icon {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  gap: 5px;
}
ion-content .header-block-title.card-text {
  font-weight: 400;
  padding-top: 15px;
}
ion-content .card {
  background: #231f20;
  border-radius: 6px;
  padding: 25px;
  margin: 12px auto;
}
ion-content .card.with-border {
  border: 1px solid #bedbff;
  padding: 20px;
}
ion-content .card p {
  color: var(--ion-color-white);
}
ion-content .card .card-title {
  font-family: Arial;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
ion-content .card .card-subtitle {
  font-family: Arial;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
ion-content .card .card-subtitle.status {
  padding: 10px 13px;
  color: #000;
  background-color: var(--ion-color-white);
  border-radius: 3px;
  line-height: normal;
}
ion-content .checkout-card {
  background: #231f20;
  border: 1px solid #383838;
  border-radius: 10px;
  color: var(--ion-color-white);
  margin: 12px auto;
}
ion-content .checkout-card .checkout-item-header {
  border-bottom: 1px solid #383838;
  padding: 10px;
}
ion-content .checkout-card .checkout-item {
  border-bottom: 1px solid #121212;
  padding: 10px;
}
ion-content .checkout-card .checkout-item:last-child {
  border-bottom: none;
}
ion-content .card-info {
  padding: 12px 2px;
}
ion-content .border-block {
  border-top: 1px solid #e5e7eb;
}
ion-content.eintracht .header-bg {
  background-image: url('email-confiramation-eintracht-header-bg.png');
  background-size: cover;
}
ion-content.eintracht .footer-bg {
  background-image: url('eintracht-email-confirmation-bg.png');
}
ion-content.eintracht .card .card-subtitle.status {
  background-color: #e30613;
  color: var(--ion-color-white);
}
ion-content.eintracht.white-thema .card {
  background: var(--ion-color-white);
}
ion-content.eintracht.white-thema .card.with-border {
  border-color: var(--ion-color-white);
}
ion-content.eintracht.white-thema .card p {
  color: var(--ion-color-black);
}
ion-content.eintracht.white-thema .checkout-card {
  background: var(--ion-color-white);
  color: var(--ion-color-black);
}
ion-content.eintracht.white-thema .checkout-card .header-block-title {
  color: var(--ion-color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/email-confirmation/email-confirmation.page.scss"],"names":[],"mappings":"AAEA;EACC,oCAAA;AADD;AAGC;EACC,0DAAA;EACA,4BAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;AADF;AAGE;EACC,WAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AADH;AAIC;EACC,kDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAFF;AAIC;EACC,kBAAA;EACA,UAAA;AAFF;AAGE;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AADH;AAGE;EACC,WAAA;EACA,YAAA;AADH;AAGE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AADH;AAGE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AADH;AAIC;EACC,aAAA;AAFF;AAIC;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,oBAAA;AAFF;AAGE;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADH;AAGE;EACC,gBAAA;EACA,iBAAA;AADH;AAIC;EACC,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAFF;AAIE;EACC,yBAAA;EACA,aAAA;AAFH;AAKE;EACC,6BAAA;AAHH;AAKE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHH;AAKE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHH;AAKG;EACC,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAOC;EACC,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;AALF;AAOE;EACC,gCAAA;EACA,aAAA;AALH;AAOE;EACC,gCAAA;EACA,aAAA;AALH;AAMG;EACC,mBAAA;AAJJ;AAQC;EACC,iBAAA;AANF;AAQC;EACC,6BAAA;AANF;AAUE;EACC,oEAAA;EACA,sBAAA;AARH;AAUE;EACC,4DAAA;AARH;AAYI;EACC,yBAAA;EACA,6BAAA;AAVL;AAeG;EACC,kCAAA;AAbJ;AAcI;EACC,oCAAA;AAZL;AAcI;EACC,6BAAA;AAZL;AAeG;EACC,kCAAA;EACA,6BAAA;AAbJ;AAeI;EACC,6BAAA;AAbL","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n\t--background: var(--ion-color-black);\n\n\t.header-bg {\n\t\tbackground-image: url('../../../assets/eintracht/email-confiramation-header-bg.png');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: top center;\n\t\tbackground-size: auto;\n\t\tposition: relative;\n\t\tbackground-color: #121212cc;\n\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tbackground-color: #121212cc;\n\t\t\tdisplay: block;\n\t\t\theight: 100%;\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\tz-index: 1;\n\t\t}\n\t}\n\t.footer-bg {\n\t\tbackground-image: url('../../../assets/eintracht/email-confirmation-bg.png');\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t\twidth: 100%;\n\t\theight: 156px;\n\t}\n\t.content {\n\t\tposition: relative;\n\t\tz-index: 2;\n\t\t.logo {\n\t\t\theight: 50px;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 50px;\n\t\t\tmargin-bottom: 25px;\n\t\t}\n\t\t.success {\n\t\t\twidth: 100%;\n\t\t\theight: 64px;\n\t\t}\n\t\t.title {\n\t\t\tfont-family: Arial;\n\t\t\tfont-weight: 900;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 24px;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-white);\n\t\t\tmargin-top: 25px;\n\t\t}\n\t\t.subtitle {\n\t\t\tfont-family: Arial;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 16px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #d6d6d6;\n\t\t\tmargin-top: 18px;\n\t\t}\n\t}\n\t.wrapper {\n\t\tpadding: 32px;\n\t}\n\t.header-block-title {\n\t\tfont-family: Arial;\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tcolor: var(--ion-color-white);\n\t\tpadding-bottom: 12px;\n\t\t&.with-icon {\n\t\t\tpadding-bottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 5px;\n\t\t}\n\t\t&.card-text {\n\t\t\tfont-weight: 400;\n\t\t\tpadding-top: 15px;\n\t\t}\n\t}\n\t.card {\n\t\tbackground: #231f20;\n\t\tborder-radius: 6px;\n\t\tpadding: 25px;\n\t\tmargin: 12px auto;\n\n\t\t&.with-border {\n\t\t\tborder: 1px solid #bedbff;\n\t\t\tpadding: 20px;\n\t\t}\n\n\t\tp {\n\t\t\tcolor: var(--ion-color-white);\n\t\t}\n\t\t.card-title {\n\t\t\tfont-family: Arial;\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 24px;\n\t\t}\n\t\t.card-subtitle {\n\t\t\tfont-family: Arial;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 24px;\n\n\t\t\t&.status {\n\t\t\t\tpadding: 10px 13px;\n\t\t\t\tcolor: #000;\n\t\t\t\tbackground-color: var(--ion-color-white);\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tline-height: normal;\n\t\t\t}\n\t\t}\n\t}\n\t.checkout-card {\n\t\tbackground: #231f20;\n\t\tborder: 1px solid #383838;\n\t\tborder-radius: 10px;\n\t\tcolor: var(--ion-color-white);\n\t\tmargin: 12px auto;\n\n\t\t.checkout-item-header {\n\t\t\tborder-bottom: 1px solid #383838;\n\t\t\tpadding: 10px;\n\t\t}\n\t\t.checkout-item {\n\t\t\tborder-bottom: 1px solid #121212;\n\t\t\tpadding: 10px;\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\t\t}\n\t}\n\t.card-info {\n\t\tpadding: 12px 2px;\n\t}\n\t.border-block {\n\t\tborder-top: 1px solid #e5e7eb;\n\t}\n\n\t&.eintracht {\n\t\t.header-bg {\n\t\t\tbackground-image: url('../../../assets/eintracht/email-confiramation-eintracht-header-bg.png');\n\t\t\tbackground-size: cover;\n\t\t}\n\t\t.footer-bg {\n\t\t\tbackground-image: url('../../../assets/eintracht/eintracht-email-confirmation-bg.png');\n\t\t}\n\t\t.card {\n\t\t\t.card-subtitle {\n\t\t\t\t&.status {\n\t\t\t\t\tbackground-color: #e30613;\n\t\t\t\t\tcolor: var(--ion-color-white);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.white-thema {\n\t\t\t.card {\n\t\t\t\tbackground: var(--ion-color-white);\n\t\t\t\t&.with-border {\n\t\t\t\t\tborder-color: var(--ion-color-white);\n\t\t\t\t}\n\t\t\t\tp {\n\t\t\t\t\tcolor: var(--ion-color-black);\n\t\t\t\t}\n\t\t\t}\n\t\t\t.checkout-card {\n\t\t\t\tbackground: var(--ion-color-white);\n\t\t\t\tcolor: var(--ion-color-black);\n\n\t\t\t\t.header-block-title{\n\t\t\t\t\tcolor: var(--ion-color-black);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
